/**
 * Formats a card number string by grouping digits into sets of four, separated by spaces.
 *
 * @param cardNumber - The card number to be formatted.
 *
 * @example
 * FormatCardNumber('7825990000812290') => '7825 9900 0081 2290'
 */
export const formatReadableCardNumber = (cardNumber: string): string => {
	return cardNumber.replace(/(.{4})/g, '$1 ').trim();
};
